module.exports = __webpack_public_path__ + "img/gdq_gbt894_1_1986.prt.5e9ee2ee.jpg";